export class DocmergeTemplateSectionConfig {
  required: boolean;
  templateEntityType: string | null;
  templateFileTypes: string[];
  editable: boolean;
  editRequired: boolean;
  defaultTemplate: string | null;

  constructor(
    required: boolean = true,
    templateEntityType: string | null = null,
    templateFileTypes: string[] = [],
    editable: boolean = false,
    editRequired: boolean = false,
    defaultTemplate: string | null = null
  ) {
    this.required = required;
    this.templateEntityType = templateEntityType;
    this.templateFileTypes = templateFileTypes;
    this.editable = editable;
    this.defaultTemplate = defaultTemplate;
    this.editRequired = editRequired;
  }

  static clone(config: DocmergeTemplateSectionConfig): DocmergeTemplateSectionConfig {
    return new DocmergeTemplateSectionConfig(
      config.required,
      config.templateEntityType,
      JSON.parse(JSON.stringify(config.templateFileTypes ?? [])),
      config.editable,
      config.editRequired,
      config.defaultTemplate
    );
  }
}
